import { Monitor } from '@paragon/monitoring';

let configuredMonitor: Monitor | null = null;

export function setMonitorForNotificationTools(monitor: Monitor) {
  configuredMonitor = monitor;
}

export function getAppMonitor() {
  return configuredMonitor;
}
